//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Issue.js";
import "../no/NXObject.js";
let d=[[[0,"IsReadOnly",0,0],[0,"StringValue",0,0],[0,"ValueType",0,0]],[[["nChoices"],"GetChoices",{R_:{choices:""}},0,0],[[],"GetDefaultChoice",{R_:{defaultChoice:''}},0,0]],[]];
SPLM.Issue.IssueProperty = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Issue.IssueProperty";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Issue.IssueProperty.Type = Object.freeze({
    "Text" : "Text", "Note" : "Note", "User" : "User", "Choice" : "Choice", "Url" : "Url", "Boolean" : "Boolean", "Date" : "Date", "Number" : "Number", "Integer" : "Integer", "Point3D" : "Point3D", "Vector3D" : "Vector3D"});

export default SPLM;